@if (data.showRemoveWhenQuantityIsMinimum && control.value <= min) {
  <button
    (click)="remove.emit()"
    [class.focus]="input.focused"
    [disabled]="data.attributes?.disabled || loading"
    mat-button
    type="button"
  >
    <ui-icon faName="trash" faStyle="light"></ui-icon>
  </button>
} @else {
  <button
    (click)="decrement()"
    [class.focus]="input.focused"
    [disabled]="control.value <= min || data.attributes?.disabled || loading"
    mat-button
    type="button"
  >
    <ui-icon faName="minus" faStyle="light"></ui-icon>
  </button>
}

<div class="quantity-count" [class.loading]="loading">
  <input
    #input="matInput"
    (blur)="onBlur()"
    [control]="control"
    [data]="data"
    [formControl]="control"
    matInput
    type="number"
    uiFormInputAttributes
    uiFormInputValidators
  >
  <ui-icon class="spinner" faName="spinner-third" faStyle="light" animation="spin"></ui-icon>
</div>

<button
  (click)="increment()"
  [disabled]="((max || max === 0) && control.value >= max) || data.attributes?.disabled || loading"
  mat-button type="button"
>
  <ui-icon faName="plus" faStyle="light"></ui-icon>
</button>
